import script from "./ProjectBlockPageContacts.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectBlockPageContacts.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectBlockPageContacts.vue?vue&type=style&index=0&id=4bcbdae8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bcbdae8"]])

export default __exports__